import React, { useState } from 'react';
import {
  Animated,
  Modal,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Dimensions,
} from 'react-native';
import { checkEventCode } from '../../services/api/mytrips.service';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import Button from '../Button';
import InputForm from '../InputForm';

export default function EventAuthModal({ showEventModal, eventKey }) {
  const [eventCode, setEventCode] = useState();
  const [infoText, setInfoText] = useState();
  const [eventCodeVerified, setEventCodeVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleClick() {
    if (eventCode) {
      setInfoText('');
      setLoading(true);
      const verification = await checkEventCode(eventKey, eventCode);
      if (!verification) {
        setInfoText('Enter valid event code.');
      }
      setEventCodeVerified(verification);
      setLoading(false);
    } else {
      setInfoText('Event code field is required!');
    }
  }
  const toggleEventModal =
    showEventModal && !eventCodeVerified
      ? true
      : showEventModal && eventCodeVerified
      ? false
      : false;

  return (
    <Modal animationType="none" transparent={true} visible={toggleEventModal}>
      <View style={styles.container}>
        <TouchableWithoutFeedback>
          <View style={styles.overlay} />
        </TouchableWithoutFeedback>
        <Animated.View style={styles.contentContainer}>
          <View style={styles.content}>
            <BaseText style={{ color: Color.grayText, ...CommonProperties.h3 }}>
              Enter Event Code
            </BaseText>
            <InputForm
              errorMessage={infoText}
              value={eventCode}
              onChangeText={(text) => setEventCode(text)}
            />
          </View>
          <View style={styles.action}>
            <Button
              style={styles.submitButton}
              label="Submit"
              labelStyle={CommonStyles.h3}
              onPress={handleClick}
              loading={loading}
            />
          </View>
        </Animated.View>
      </View>
    </Modal>
  );
}

const { height, width } = Dimensions.get('window');
const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  overlay: {
    width: width,
    height: height,
    position: 'absolute',
    backgroundColor: 'rgba(52,52,52,0.5)',
    top: 0,
  },
  contentContainer: {
    maxWidth: '80%',
    borderRadius: 5,
    backgroundColor: 'white',
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 75,
    paddingRight: 75,
  },
  content: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },
  action: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginTop: 5,
  },
});
